module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/180-french-polynesia-73765dbc480838e8a0cc0ad562867569.svg";